import React from "react";
import { useTranslate, IResourceComponentsProps } from "@pankod/refine-core";
import {  Create, useForm } from "@pankod/refine-antd";
import { IEquipment, IPartner, IPartnerCategory } from "interfaces";
import { EquipmentForm } from "./form";

export const EquipmentCreate: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps, queryResult, form, formLoading, onFinish, mutationResult } = useForm<IEquipment>({ 'redirect': 'edit' });

  return (
    <Create saveButtonProps={saveButtonProps} title={`${t("buttons.create")}s ${t("menu.equipments")}`}>
      <EquipmentForm form={form} queryResult={queryResult} formLoading={formLoading} formProps={formProps} />
    </Create>
  );
};
